export default __webpack_public_path__ + "static/media/8.6bf8d8ff.png";